import * as React from 'react';
import styled from 'styled-components';

import { verticalSpace } from '@doltech/utils/lib/css-style';

const Container = styled.div`
  ${verticalSpace(24)}
`;

interface SectionVocabQuestionListGroupLayoutProps {
  children?: React.ReactNode;
}

export const SectionVocabQuestionListGroupLayout = (
  props: SectionVocabQuestionListGroupLayoutProps
) => {
  const { children } = props;

  return <Container className="section-vocab-question-list-group-layout">{children}</Container>;
};
